<template>
  <div>
    <v-text-field
      :disabled="disabled"
      :placeholder="formUpdate ? textFormUpdate : 'Pesquise o residente'"
      v-model="query"
      id="query"
      name="query"
      list="residents"
      v-on:input="getResidentsLike"
      autocomplete="off"
      :ref="refautofocus ? 'autofocus' : ''"
      label="Pesquise o residente"
      outlined
      dense
    />
    <datalist id="residents">
      <option
        v-for="resident in residents"
        :key="resident.id"
        :value="`(${resident.id}) ${resident.name}`"
      >
        {{ `(${resident.id}) ${resident.name}` }}
      </option>
    </datalist>
  </div>
</template>

<script>
import api from "../../services/api";
import { numbersOnly } from "../../lib/format";

export default {
  name: "SelectResidentID",
  props: {
    value: [String, Number],
    refautofocus: Boolean,
    disabled: Boolean,
    formUpdate: Boolean,
    textFormUpdate: [String],
  },
  components: {},
  data() {
    return {
      resident_id: undefined,
      query: undefined,
      residents: [],
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    async retrieve() {
      try {
        if (!this.value) {
          return;
        }

        this.resident_id = this.value;

        let params = { id: this.resident_id };
        let response = await api.get("/rest-home/resident", {
          params,
        });

        const { error, errors, resident } = response.data;
        if (error) {
          console.log(errors);
        } else {
          this.query = `(${resident.id}) ${resident.name}`;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getResidentsLike() {
      this.resident_id = numbersOnly(this.query.split(") ", 1)[0]);
      this.$emit("input", this.resident_id);

      if (this.query.length > 0) {
        let { query } = this;
        query = this.query.replace(`(${this.resident_id}) `, "");

        let params = { query };

        const response = await api.get("/rest-home/residents/name-like", {
          params,
        });

        const { error, residents } = response.data;

        if (!error) {
          this.residents = residents;
        }
      }
    },
  },
};
</script>
